import React from "react";
import { Section } from "./Elements/Section";
import { Card } from "./Elements/Card";

const steps = [
  { t: "Discover", d: "Understand goals, constraints, and success metrics." },
  {
    t: "Design",
    d: "Architecture, UX, and delivery plan with measurable milestones.",
  },
  { t: "Build", d: "Agile sprints, CI/CD, and transparent demos every week." },
  { t: "Launch", d: "Harden, scale, and cutover with runbooks and SLOs." },
  { t: "Evolve", d: "Roadmap, A/B testing, and ongoing optimization." },
];

export const Process = () => {
  return (
    <Section
      id="process"
      eyebrow="How we work"
      title="Delivery process"
      subtitle="Simple, transparent, and geared for speed without surprises."
    >
      <ol className="grid sm:grid-cols-2 lg:grid-cols-5 gap-6">
        {steps.map((s, i) => (
          <li key={s.t} className="relative">
            <Card>
              <div className="text-sm text-gray-500">Step {i + 1}</div>
              <h3 className="font-semibold text-gray-900">{s.t}</h3>
              <p className="mt-1 text-sm text-gray-600">{s.d}</p>
            </Card>
          </li>
        ))}
      </ol>
    </Section>
  );
};
